import { PermissionCode } from '@gb-ticket/shared-types';
import { useVoiceCopy } from '@/platform/voice/use-voice';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { hasPermission } from '@/features/auth/permissions';
import { useMe } from '@/features/auth/use-me';
import { PORTAL_ROOT } from '@/products/helpdesk/features/portal/portal-paths';
import { AgentWorkDashboard } from '@/products/helpdesk/features/tickets/agent-work-dashboard';
import { usePageTitle } from '@/hooks/use-page-title';

export function HomePage() {
  const copy = useVoiceCopy();
  const me = useMe();
  const isAgent = hasPermission(me.data, PermissionCode.TICKETS_READ_ALL);
  usePageTitle('Übersicht');

  if (me.data && isAgent) {
    return <AgentWorkDashboard user={me.data} />;
  }

  return (
    <section className="mx-auto max-w-2xl space-y-6 text-center">
      <h1 className="text-3xl font-bold tracking-tight">Willkommen im Helpdesk</h1>
      <p className="text-muted-foreground">
        {me.data ? copy('helpdesk.home.desk') : copy('helpdesk.home.sign-in')}
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        {!me.data && (
          <Button asChild>
            <Link to="/anmelden">Anmelden</Link>
          </Button>
        )}
        {me.data && (
          <Button asChild>
            <Link to={PORTAL_ROOT}>Zur IT-Hilfe</Link>
          </Button>
        )}
      </div>
    </section>
  );
}
